// extracted by mini-css-extract-plugin
module.exports = {"container":"IntercomLoaderWrapper_container__FVd0v","disabled":"IntercomLoaderWrapper_disabled__9rWKi"};